module.exports = __webpack_public_path__ + "img/audience.605c531b.png";